import React, { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import EngIMG from '../assets/English.jpg';
import SpanishIMG from '../assets/Spanish.png';
import { useTranslation } from "react-i18next";

const LangChange = (props) => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [language, setLanguage] = React.useState();
  const open = Boolean(anchorEl);
  const { language } = props;

  // useEffect(() => {
  //   if (i18n.language === 'en') {
  //     setLanguage('ENG');
  //   } else if (i18n.language === 'es') {
  //     setLanguage('ESP');
  //   }
  //   console.log(i18n.language)
  // }, [i18n.language]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // if (option === 'ENG') {
    //   setLanguage('ENG');
    // } else if (option === 'ESP') {
    //   setLanguage('ESP');
    // }
  };

  const returnLanguageImage = () => {
    if (i18n.language === 'en' || i18n.language === 'en-US' || i18n.language === undefined || i18n.language === null || i18n.language.includes("en")) {
      return EngIMG;
    } else if (i18n.language === 'es') {
      return SpanishIMG;
    }
  };

  return (
    <div
      className="lang-change-btn"
      style={{
        display: "flex",
        border: "solid gray 1px",
        borderRadius: "2rem",
        fontSize: "inherit",
        padding: "0 5px",
        alignItems: "center"
      }}
    >
      <IconButton
        aria-label="more"
        id="long-button"
        onClick={handleClick}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{ fontSize: '1rem', fontWeight: 600, padding: "6px", color: 'black' }}
      >
        {language} 
        {/* <img style={{marginRight: 0}} className="lang-img" src={(i18n.language === 'en' || i18n.language === 'en-US') ? EngIMG : SpanishIMG} alt={i18n.language === 'en' ? "English" : "Spanish"} /> */}
        {/* <LanguageOutlinedIcon sx={{ fontSize: 22, color: 'black' }} /> */}
      </IconButton>
      <Menu
        id="long-menu"
        data-testid="menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        className="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        PaperProps={{
          elevation: 0,
          style: {
            marginTop: 15,
            width: "auto",
          },
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => props.changeLanguage('en')}>
          <div className="lang-img-container">
            {/* <img className="lang-img" src={EngIMG} alt="English" /> */}
            English
          </div>
        </MenuItem>
        <MenuItem onClick={() => props.changeLanguage('es')}>
          <div className="lang-img-container">
            {/* <img className="lang-img" src={SpanishIMG} alt="Spanish" /> */}
            Spanish (Latin American)
          </div>
        </MenuItem>
      </Menu>
      <style jsx>{`
        .lang-img-container {
          display: flex;
          align-items: center;
        }
        
        .lang-img {
          width: 25px;
          height: 20px;
          margin-right: 8px;
        }
      `}</style>
    </div>
  );
};

export default LangChange;
